import { backendClient } from '../../api/backend';
import {
  FETCH_DEVICES_REQUEST,
  FETCH_DEVICES_SUCCESS,
  FETCH_DEVICES_FAILURE,
  REMOVE_DEVICE_REQUEST,
  REMOVE_DEVICE_SUCCESS,
  REMOVE_DEVICE_FAILURE,
  RENAME_DEVICE_REQUEST,
  RENAME_DEVICE_SUCCESS,
  RENAME_DEVICE_FAILURE,
  CLEAR_DEVICE_ERROR
} from './types';

// Action Creators
const fetchDevicesRequest = () => ({
  type: FETCH_DEVICES_REQUEST
});

const fetchDevicesSuccess = (devices) => ({
  type: FETCH_DEVICES_SUCCESS,
  payload: devices
});

const fetchDevicesFailure = (error) => ({
  type: FETCH_DEVICES_FAILURE,
  payload: error
});

const removeDeviceRequest = (deviceId) => ({
  type: REMOVE_DEVICE_REQUEST,
  payload: deviceId
});

const removeDeviceSuccess = (deviceId) => ({
  type: REMOVE_DEVICE_SUCCESS,
  payload: deviceId
});

const removeDeviceFailure = (error) => ({
  type: REMOVE_DEVICE_FAILURE,
  payload: error
});

const renameDeviceRequest = (deviceId) => ({
  type: RENAME_DEVICE_REQUEST,
  payload: deviceId
});

const renameDeviceSuccess = (device) => ({
  type: RENAME_DEVICE_SUCCESS,
  payload: device
});

const renameDeviceFailure = (error) => ({
  type: RENAME_DEVICE_FAILURE,
  payload: error
});

export const clearDeviceError = () => ({
  type: CLEAR_DEVICE_ERROR
});

// Thunk Actions
export const fetchUserDevices = () => {
  return async (dispatch) => {
    dispatch(fetchDevicesRequest());
    try {
      const devices = await backendClient.getUserDevices();
      dispatch(fetchDevicesSuccess(devices));
    } catch (error) {
      let errorMessage = "Impossible de récupérer les appareils.";
      if (error.message) {
        errorMessage = error.message;
      }
      dispatch(fetchDevicesFailure(errorMessage));
    }
  };
};

export const removeDevice = (deviceId) => {
  return async (dispatch) => {
    dispatch(removeDeviceRequest(deviceId));
    try {
      // Use the removeDevice method from backendClient which ensures the session is disconnected
      await backendClient.removeDevice(deviceId);
      
      // If successful, dispatch success action
      dispatch(removeDeviceSuccess(deviceId));
    } catch (error) {
      let errorMessage = "Impossible de déconnecter l'appareil.";
      if (error.status === 400) {
        errorMessage = "Impossible de déconnecter l'appareil actuel. Utilisez la déconnexion à la place.";
      } else if (error.status === 404) {
        errorMessage = "Appareil non trouvé.";
      } else if (error.message) {
        errorMessage = error.message;
      }
      dispatch(removeDeviceFailure(errorMessage));
    }
  };
};

export const renameDevice = ({ deviceId, newName }) => {
  return async (dispatch) => {
    dispatch(renameDeviceRequest(deviceId));
    try {
      // Use the renameDevice method from backendClient
      const updatedDevice = await backendClient.renameDevice({ deviceId, newName });
      dispatch(renameDeviceSuccess(updatedDevice));
    } catch (error) {
      let errorMessage = "Impossible de renommer l'appareil.";
      if (error.status === 404) {
        errorMessage = "Appareil non trouvé.";
      } else if (error.message) {
        errorMessage = error.message;
      }
      dispatch(renameDeviceFailure(errorMessage));
    }
  };
};